import { useState } from 'react';
import { usePilgrimsStore } from '../stores/pilgrimsStore';
import { usePackagesStore } from '../stores/packagesStore';
import { useFlightsStore } from '../stores/flightsStore';
import { VerificationResult, VerificationStats } from '../types/verification';

export const useVerification = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [results, setResults] = useState<VerificationResult[] | null>(null);
  const [stats, setStats] = useState<VerificationStats | null>(null);

  const { pilgrims } = usePilgrimsStore();
  const { packages } = usePackagesStore();
  const { flights } = useFlightsStore();

  const verify = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const verificationResults: VerificationResult[] = [];
      const pilgrimsList = Object.values(pilgrims);
      let invalidPackages = 0;
      let invalidPNRs = 0;

      // Verify each pilgrim
      pilgrimsList.forEach(pilgrim => {
        // Check package name
        const packageExists = Object.values(packages).some(
          pkg => pkg.name === pilgrim.package_nickName
        );
        
        if (!packageExists) {
          invalidPackages++;
          verificationResults.push({
            isValid: false,
            type: 'package',
            pilgrimName: pilgrim.Name,
            value: pilgrim.package_nickName,
            message: 'اسم الباقة غير موجود في قائمة الباقات'
          });
        }

        // Check PNR
        const flightExists = Object.values(flights).some(
          flight => flight.pnrNumber === pilgrim.PNR_NO
        );

        if (!flightExists) {
          invalidPNRs++;
          verificationResults.push({
            isValid: false,
            type: 'pnr',
            pilgrimName: pilgrim.Name,
            value: pilgrim.PNR_NO,
            message: 'رقم PNR غير موجود في قائمة الرحلات'
          });
        }
      });

      // Calculate error percentage
      const totalIssues = invalidPackages + invalidPNRs;
      const errorPercentage = Math.round((totalIssues / (pilgrimsList.length * 2)) * 100);

      // Set stats
      setStats({
        totalPilgrims: pilgrimsList.length,
        invalidPackages,
        invalidPNRs,
        errorPercentage
      });

      // If no issues found, add a success result
      if (verificationResults.length === 0) {
        verificationResults.push({
          isValid: true,
          type: 'package',
          pilgrimName: '',
          value: '',
          message: ''
        });
      }

      setResults(verificationResults);
    } catch (err: any) {
      setError(err.message || 'حدث خطأ أثناء التحقق');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    results,
    stats,
    verify
  };
};